import { useSessionStorage } from '@vueuse/core'

declare interface Intention {
  event?: components['schemas']['Event']
  zone?: components['schemas']['Zone']
  box?: components['schemas']['Box']
  order?: components['schemas']['Order']
  api_order?: any
  payment?: components['schemas']['Payment']
  count?: number
}

export function usePurchase() {
  const initialIntention = {
    event: undefined,
    zone: undefined,
    box: undefined,
    order: undefined,
    api_order: undefined,
    payment: undefined,
    count: undefined,
  }

  const intention = useSessionStorage<Intention>('Intention', initialIntention)

  const resetIntention = () => {
    intention.value = initialIntention
  }

  return { intention, resetIntention }
}
